module.exports = __webpack_public_path__ + "static/img/12.288494e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/eng/12.png
// module id = WztY
// module chunks = 0